import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import FormDialog from "components/modals/FormDialog";
import useAuthorized from "hooks/useAuthorized";
import { useTagCategoryMutations } from "hooks/useTagCategoryTable";
import TagCategoryForm from "./forms/TagCategoryForm";

export const TagCategoryTableActions = ({ original, onSuccess }) => {
  const canEdit = useAuthorized([ACL_RELATIONSHIPS.tagCategory.edit]);
  const canDelete = useAuthorized([ACL_RELATIONSHIPS.tagCategory.delete]);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const { remove } = useTagCategoryMutations({
    onDeleted: () => setDeleteOpen(false),
  });

  if (!canEdit && !canDelete) {
    return null;
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Tag category actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <FormDialog
        FormComponent={TagCategoryForm}
        model={original}
        modelType="Tag Category"
        open={editOpen}
        onOpenChange={setEditOpen}
        onSuccess={onSuccess}
      />
      <ConfirmDeleteDialog
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        title="Delete tag category?"
        description="Are you sure you want to delete this Tag Category?"
        onConfirm={() => remove.mutate(original.id)}
      />
    </>
  );
};
